// extracted by mini-css-extract-plugin
export default {"page":"LoginPage_page__pRwiW"};